import Cookies from 'js-cookie'

const TokenKey = 'USER-T'

export function getToken() {
  return Cookies.get(TokenKey)
  // return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 7, path: '/' })
  // return localStorage.setItem(TokenKey,token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
  // return localStorage.removeItem(TokenKey)
}

const UserInfoKey = 'USER-INFO'

export function setUserInfo(userInfo) {
  return localStorage.setItem(UserInfoKey, JSON.stringify(userInfo))
}

export function getUserInfo() {
  const userInfo = localStorage.getItem(UserInfoKey)
  return userInfo ? JSON.parse(userInfo) : null
}

export function removeUserInfo() {
  return localStorage.removeItem(UserInfoKey)
}

const MenuListKey = 'MENU-LIST'

export function setMenuList(menuList) {
  return localStorage.setItem(MenuListKey, JSON.stringify(menuList))
}

export function getMenuList() {
  const menuList = localStorage.getItem(MenuListKey)
  return menuList ? JSON.parse(menuList) : null
}

export function removeMenuList() {
  return localStorage.removeItem(MenuListKey)
}